module.exports = __webpack_public_path__ + "img/2695-6.bb579b94.png";